module.exports = __webpack_public_path__ + "img/ons_campaign_2_desc.f0f6a61b.png";